import MatxLayout from '../components/MatxLayout/MatxLayout'
import React from 'react'
import profileRoutes from '../views/profile/ProfileRoutes'
import MeasurementRoutes from '../views/measurment/MeasurementRoutes'
import alertsRoutes from '../views/alerts/AlertsRoutes'
import dashboardsRoutes from '../views/dashboard/DashboardsRoutes'
import sessionRoutes from '../views/sessions/SessionRoutes'
import AuthGuard from '../auth/AuthGuard'
import usersRoutes from '../views/users/UsersRoutes'
import waterMetersRoutes from '../views/waterMeter/WaterMetersRoutes'
import housingCooperativePageRoutes from '../views/housingCooperative/HousingCooperativeRoot'
import documentsRoutes from '../views/documents/DocumentsRoutes'
import NotFound from '../views/sessions/NotFound'
import chirpStackRoutes from '../views/chirpStack/ChirpStackRoutes'
import constAllocationRoutes from '../views/costAllocation/CostAllocationRoutes'
import contactRoutes from '../views/contact/ContactRoutes'

export const AllPages = () => {
	const all_routes = [
		{
			path: '/',
			element: (
				<AuthGuard>
					<MatxLayout />
				</AuthGuard>
			),
			children: [
				...dashboardsRoutes,
				...profileRoutes,
				...MeasurementRoutes,
				...alertsRoutes,
				...usersRoutes,
				...waterMetersRoutes,
				...housingCooperativePageRoutes,
				...documentsRoutes,
				...chirpStackRoutes,
				...constAllocationRoutes,
				...contactRoutes
			]
		},
		...sessionRoutes,
		{
			path: '*',
			element: <NotFound />
		}
	]

	return all_routes
}
